import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Bulb24, DangerLiner24, CloseCircleLiner24 } from '../../icons';
import { Typography } from '../Typography';
import styles from './Callout.module.scss';
const iconsMap = {
    info: /*#__PURE__*/ _jsx(Bulb24, {
        width: 18,
        height: 18
    }),
    warning: /*#__PURE__*/ _jsx(DangerLiner24, {
        width: 18,
        height: 18
    }),
    error: /*#__PURE__*/ _jsx(CloseCircleLiner24, {
        width: 18,
        height: 18
    })
};
export function Callout(props) {
    const { intent = 'info', icon, footer, withAction, className, children, weight, variant, hideIcon, withBorder, testId, classes } = props, rest = _object_without_properties(props, [
        "intent",
        "icon",
        "footer",
        "withAction",
        "className",
        "children",
        "weight",
        "variant",
        "hideIcon",
        "withBorder",
        "testId",
        "classes"
    ]);
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({
        className: cn(styles.root, styles[intent], {
            [styles.border]: withBorder
        }, classes === null || classes === void 0 ? void 0 : classes.wrapper, className),
        "data-testid": testId
    }, rest), {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.main, classes === null || classes === void 0 ? void 0 : classes.main),
                children: [
                    !hideIcon && /*#__PURE__*/ _jsx("div", {
                        className: styles.icon,
                        children: icon || iconsMap[intent]
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        className: styles.content,
                        weight: weight,
                        variant: variant,
                        children: children
                    }),
                    withAction
                ]
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.footer, classes === null || classes === void 0 ? void 0 : classes.footer),
                children: footer
            })
        ]
    }));
}
